import React from "react";

interface HeroLogoProps {
  useBlueLogo?: boolean;
  hideHeaderLogo?: boolean;
  logoPosition?: 'top-left' | 'center';
  hideHeroLogo?: boolean;
}

const HeroLogo = React.forwardRef<HTMLDivElement, HeroLogoProps>(({
  useBlueLogo = true,
  hideHeaderLogo = false,
  logoPosition = 'center',
  hideHeroLogo = true
}, ref) => {
  if (hideHeaderLogo || hideHeroLogo) return null;
  
  const logoUrl = useBlueLogo 
    ? "/images/jh-logo-dark.png" 
    : "/images/jh-logo-dark.png";

  return (
    <div ref={ref} className={`${logoPosition === 'top-left' ? 'mx-0 mb-8' : 'mx-auto mb-12'} max-w-[200px] animate-fade-in`}>
      <img 
        src={logoUrl} 
        alt="Jörg Hörmann - Coaching & Consulting Logo" 
        className="w-full h-auto" 
      />
    </div>
  );
});

HeroLogo.displayName = "HeroLogo";

export default HeroLogo;
